<template bindable="block, indicate">
  <div class="af-progress__blocker" show.bind="block"></div>
  <svg class="af-progress__indicator" xmlns="http://www.w3.org/2000/svg" width="100%" height="5px" viewBox="0 0 128 5" preserveAspectRatio="none" show.bind="indicate">
    <rect x="0" y="0" width="100%" height="100%" fill="lightblue" />
    <g>
      <rect x="-128" y="0" width="128" height="100%" fill="#007bff" />
      <animateTransform attributeName="transform" type="translate" from="0 0" to="256 0" dur="2500ms" repeatCount="indefinite" />
    </g>
  </svg>
</template>
